<script lang="ts">
    import type Monster from "../../lib/monster";
    import { getPathFor } from "../Attributes/util";
    import type { Point } from "../Attributes/util";
    import { convertNormalizedPath, generateFillColor } from "./util";
    export let monster: Monster;
    export let dimensions: number;
    const normalizedRange = 10;

    const generatePath = (sideLength: number): Point[] => {
        const path: Point[] = convertNormalizedPath(
            [
                { x: 3.5, y: 0.5 },
                { x: 6, y: 0.5 },
                { x: 6, y: 3 },
                { x: 5, y: 3 },
                { x: 5, y: 4 },
                { x: 7, y: 4 },
                { x: 8, y: 5 },
                { x: 8, y: 7 },
                { x: 1.5, y: 7 },
                { x: 1.5, y: 5 },
                { x: 2.5, y: 4 },
                { x: 4.5, y: 4 },
                { x: 4.5, y: 3 },
                { x: 3.5, y: 3 },
            ],
            sideLength * 1.5,
            0,
            1
        );

        return path;
    };
</script>

{#if dimensions}
    <path
        d={getPathFor(generatePath(dimensions))(
            { x: dimensions / 2, y: dimensions / 2 },
            normalizedRange
        )}
        stroke="black"
        fill={generateFillColor('health', monster)}
    />
{/if}

<style>
</style>
